
export const orderRouter = [
  {
    path: "/orderCenter/pay",
    name: "orderPay",
    meta : {
      title: "GPUEZ智算云 - 订单支付"
    },
    component: resolve => require(["@/page/control/financial/orderCenter/pay"], resolve),
  },
  {
    path: "/orderCenter/proxy",
    name: "orderProxy",
    meta : {
      title: "GPUEZ智算云 - 订单套餐"
    },
    component: resolve => require(["@/page/control/financial/orderCenter/proxy"], resolve),
  },
]


// WEBPACK FOOTER //
// ./src/router/modules/orderRouter.js